module.exports = __webpack_public_path__ + "static/media/WeChat_Guide_Chin_Android.1cf6c72a.pdf";